// @flow

import React, {useContext} from 'react';
import {StyledPopularSitesContainer, Title, Subtitle, SiteCardsContainer} from './StyledPopularSites';
import {FrameContent} from '../../../components/FrameContent/FrameContent';
import type {ILocalesTransformers} from '../../../utils/locales';
import siteslist from './siteslist.json';
import {SiteCard} from '../../../components/SiteCard/SiteCard';
import {LocalesContext} from '../../../utils/locales';
import {CarouselSiteCards} from '../../../components/CarouselSiteCards/CarouselSiteCards';

type IPopularSitesProps = {
    isMobileUser: boolean;
}

export const PopularSites = ({isMobileUser}: IPopularSitesProps): any => {
    const {translate}: ILocalesTransformers = useContext(LocalesContext);

    return (
        <StyledPopularSitesContainer>
            <FrameContent>
                <Title>{translate('pages.scorecard.error.popular.title')}</Title>
                <Subtitle>{translate('pages.scorecard.error.popular.subtitle')}</Subtitle>
                 { isMobileUser ? <CarouselSiteCards sitesToMap={siteslist} />
                 : <SiteCardsContainer>
                        { siteslist.map((site: Object): any => {
                            return (
                                <SiteCard
                                    key={site.name}
                                    imgPath={site.image}
                                    iconPath={site.icon}
                                    title={site.name}
                                    subtitle={site.reviews}
                                    rating={site.rating}
                                    starsPath={site.stars}
                                />
                            );
                        })}
                    </SiteCardsContainer>
                 }
            </FrameContent>
        </StyledPopularSitesContainer>
    );
};
